import { styled as e } from "styled-components";
const l = e.th`
  width: 14%;
`, i = e.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
`;
export {
  l as TableHeaderCell,
  i as TableHeaderCellTextContainer
};
